import { render, staticRenderFns } from "./ChannelConsumption.vue?vue&type=template&id=0e9e971e&scoped=true&"
import script from "./ChannelConsumption.vue?vue&type=script&lang=js&"
export * from "./ChannelConsumption.vue?vue&type=script&lang=js&"
import style0 from "./ChannelConsumption.vue?vue&type=style&index=0&id=0e9e971e&prod&lang=scss&scoped=true&"
import style1 from "./ChannelConsumption.vue?vue&type=style&index=1&id=0e9e971e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e971e",
  null
  
)

export default component.exports